'use client';

import React, { HTMLAttributes, PropsWithChildren, useCallback } from 'react';
import { useRouter } from 'next/navigation';

import { useClientTranslation } from '@/lib/i18n/client';
import { SearchResults } from '@/lib/models/Search';
import { SearchDropdownResults } from '@/shared/SearchDropdown/components/SearchDropdownResults';
import { SearchDropdownEmpty } from '@/shared/SearchDropdown/components/SearchDropdownEmpty';
import { SearchDropdownWrapper } from '@/shared/SearchDropdown/components/SearchDropdownWrapper';

interface SearchDropdownProps extends Omit<HTMLAttributes<HTMLDivElement>, 'results'> {
  query: string;
  results: SearchResults | null;
  close: (isOpen: boolean) => void;
}

export function SearchDropdown({ query, results, close, children, className }: PropsWithChildren<SearchDropdownProps>) {
  const { t } = useClientTranslation('search');
  const router = useRouter();

  const handleClickShowMore = useCallback(() => {
    router.push(`/helpdesk/search?q=${query}`);
    close(false);
  }, [query, router, close]);

  if (!results?.count) {
    return (
      <SearchDropdownWrapper className={className}>
        <SearchDropdownEmpty t={t} />
      </SearchDropdownWrapper>
    );
  }

  return (
    <SearchDropdownWrapper className={className}>
      {children}
      <SearchDropdownResults query={query} results={results} handleClickShowMore={handleClickShowMore} t={t} />
    </SearchDropdownWrapper>
  );
}
